import {
  DayOfWeek,
  GenericTableRowInterface,
  HourOfDay,
  NLPEventsDaysCombined,
  ProfileCollectAnalyticsDaysCombinedInterface,
  QuestAnalyticsDaysCombinedInterface,
  UserAnalyticsDaysCombinedInterface
} from "@swivl-mono/types";

import { BarAndPieChartData } from "../../Charts/BarAndPieChart/BarAndPieChart";
import { StackedBarGraphData } from "../../Charts/StackedBarGraph/StackedBarGraph";
import { MenuOption } from "../BotAnalyticsDashboard";

export function HandledDataForType(data: NLPEventsDaysCombined, type: MenuOption): StackedBarGraphData {
  let output: StackedBarGraphData = {
    ticks: [],
    segments: [[], []],
    colors: ["#00CABE", "#F67902"]
  };

  // let first:Datum[] = []
  // let second:Datum[] = []

  if (type === MenuOption.Day) {
    // let index = 0; // May need to switch back to this.
    for (const day in data.byDayOfYear) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfYear, day)) {
        let dayDate = new Date(day + "T12:00:00.000-06:00");
        let stringVersion = String(dayDate.getMonth() + 1) + "/" + String(dayDate.getDate());
        output.ticks.push(stringVersion);

        output.segments[0].push({ x: stringVersion, y: data.byDayOfYear[day].handled });
        output.segments[1].push({ x: stringVersion, y: data.byDayOfYear[day].unhandled });
        // index++;
      }
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.TimeOfDay) {
    const allHours = Object.values(HourOfDay);
    for (const timeSlot of allHours) {
      output.ticks.push(timeSlot);
      const timeData = data.byTimeOfDay[timeSlot] || { handled: 0, unhandled: 0, total: 0, falsePositive: 0 };
      output.segments[0].push({ x: timeSlot, y: timeData.handled });
      output.segments[1].push({ x: timeSlot, y: timeData.unhandled });
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.DayOfWeek) {
    const daysArray = [
      { day: "Mon", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Tue", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Wed", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Thu", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Fri", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Sat", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } },
      { day: "Sun", data: { total: 0, handled: 0, unhandled: 0, falsePositive: 0 } }
    ];
    for (const key in data.byDayOfWeek) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfWeek, key)) {
        switch (key as DayOfWeek) {
          case DayOfWeek.Monday:
            daysArray[0].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Tuesday:
            daysArray[1].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Wednesday:
            daysArray[2].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Thursday:
            daysArray[3].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Friday:
            daysArray[4].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Saturday:
            daysArray[5].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Sunday:
            daysArray[6].data = data.byDayOfWeek[key];
            break;
        }
      }
    }

    for (let i = 0; i < daysArray.length; i++) {
      const element = daysArray[i];
      output.ticks.push(element.day);
      output.segments[0].push({ x: element.day, y: element.data.handled });
      output.segments[1].push({ x: element.day, y: element.data.unhandled });
    }
  }

  return output;
}

export function UserDataForType(data: UserAnalyticsDaysCombinedInterface, type: MenuOption): StackedBarGraphData {
  let output: StackedBarGraphData = {
    ticks: [],
    segments: [[], []],
    colors: ["#F67902", "#FFA900"]
  };

  if (type === MenuOption.Day) {
    let index = 0;
    for (const day in data.byDayOfYear) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfYear, day)) {
        let dayDate = new Date(day + "T12:00:00.000-06:00");
        let stringVersion = String(dayDate.getMonth() + 1) + "/" + String(dayDate.getDate());
        output.ticks.push(stringVersion);

        output.segments[0].push({ x: stringVersion, y: data.byDayOfYear[day].newUsers });
        output.segments[1].push({ x: stringVersion, y: data.byDayOfYear[day].returningUsers });
        index++;
      }
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.TimeOfDay) {
    const allHours = Object.values(HourOfDay);
    for (const timeSlot of allHours) {
      output.ticks.push(timeSlot);
      const timeData = data.byTimeOfDay[timeSlot] || { newUsers: 0, returningUsers: 0, total: 0 };
      output.segments[0].push({ x: timeSlot, y: timeData.newUsers });
      output.segments[1].push({ x: timeSlot, y: timeData.returningUsers });
    }

    output.tickCount = 7;
  }

  if (type === MenuOption.DayOfWeek) {
    const daysArray = [
      { day: "Mon", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Tue", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Wed", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Thu", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Fri", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Sat", data: { total: 0, newUsers: 0, returningUsers: 0 } },
      { day: "Sun", data: { total: 0, newUsers: 0, returningUsers: 0 } }
    ];
    for (const key in data.byDayOfWeek) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfWeek, key)) {
        switch (key as DayOfWeek) {
          case DayOfWeek.Monday:
            daysArray[0].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Tuesday:
            daysArray[1].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Wednesday:
            daysArray[2].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Thursday:
            daysArray[3].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Friday:
            daysArray[4].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Saturday:
            daysArray[5].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Sunday:
            daysArray[6].data = data.byDayOfWeek[key];
            break;
        }
      }
    }

    for (let i = 0; i < daysArray.length; i++) {
      const element = daysArray[i];
      output.ticks.push(element.day);
      output.segments[0].push({ x: element.day, y: element.data.newUsers });
      output.segments[1].push({ x: element.day, y: element.data.returningUsers });
    }

    output.tickCount = 7;
  }

  return output;
}

export function QuestData(data: QuestAnalyticsDaysCombinedInterface): BarAndPieChartData[] {
  let output: BarAndPieChartData[] = [];

  for (const key in data.quests) {
    if (Object.prototype.hasOwnProperty.call(data.quests, key)) {
      const element = data.quests[key];
      output.push({ title: element.name, value: element.total });
    }
  }

  return output;
}

export const GenericTableData = (rawData: any[], fields?: string[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }

  const fieldsToUse = fields || Object.keys(rawData[0]).slice(10);

  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    fieldsToUse.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  return Object.keys(aggregatedData).map((key) => ({
    title: key,
    value: aggregatedData[key]
  }));
};

export const InventoryData = (rawData: any[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }
  const specificFields = ["Show Inventory", "Unit Selected", "No Available Inventory", "Search Different Store"];
  const genericData = GenericTableData(rawData, specificFields);
  const rateSum = rawData.reduce((sum, item) => sum + (parseFloat(item.Rate) || 0), 0);
  genericData.push({
    title: "Rate",
    value: rateSum
  });
  return genericData;
};

export const PayBillData = (rawData: any[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }
  const genericData = GenericTableData(rawData);
  const labelMapping: { [key: string]: string } = {
    "Navigate to Login": "Redirected to Account Login Page",
    "Navigate to Online Bill Pay Page": "Redirected to Bill Pay Page"
  };
  const mappedData = genericData.map((item) => ({
    ...item,
    title: labelMapping[item.title] || item.title
  }));
  return mappedData;
};

export const FMSData = (rawData: any[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }
  const specificFields = ["FMS Start", "Facility ID Set", "Facility ID Collected", "Not Sent to FMS", "FMS Lead Status"];
  const labelMapping: { [key: string]: string } = {
    "FMS Start": "Start",
    "FMS Lead Status": "Success"
  };
  const genericData = GenericTableData(rawData, specificFields);

  const facilityIdSet = genericData.find((item) => item.title === "Facility ID Set")?.value ?? 0;
  const facilityIdCollected = genericData.find((item) => item.title === "Facility ID Collected")?.value ?? 0;
  const notSentToFMS = genericData.find((item) => item.title === "Not Sent to FMS")?.value ?? 0;
  const fmsLeadStatus = genericData.find((item) => item.title === "FMS Lead Status")?.value ?? 0;

  const storeSelectedValue = facilityIdSet + facilityIdCollected;
  genericData.push({
    title: "Store Selected",
    value: storeSelectedValue
  });

  const leadSettingOnValue = storeSelectedValue - notSentToFMS;
  genericData.push({
    title: "Lead Setting On",
    value: leadSettingOnValue
  });

  if (fmsLeadStatus > leadSettingOnValue) {
    const leadSettingOnItem = genericData.find((item) => item.title === "Lead Setting On");
    if (leadSettingOnItem) {
      leadSettingOnItem.value = fmsLeadStatus;
    }
  }
  const mappedData = genericData.map((item) => ({
    ...item,
    title: labelMapping[item.title] || item.title
  }));
  return mappedData;
};

export function transformProfileCollectData(collections: GenericTableRowInterface[]): ProfileCollectAnalyticsDaysCombinedInterface {
  const result: ProfileCollectAnalyticsDaysCombinedInterface = {
    total: { total: 0, phoneCollections: 0, emailCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 },
    byDayOfWeek: {},
    byDayOfYear: {},
    byTimeOfDay: {}
  };
  const validHours = Object.values(HourOfDay);
  collections.forEach((collection) => {
    // Skip deleted items - deletedDate comes as a mapped column
    if (collection["deletedDate"]) {
      return;
    }

    const updatedDate = new Date(collection.updatedAt);
    const dayOfWeek = updatedDate.toLocaleString("en-US", { weekday: "long" }) as DayOfWeek;
    const dayOfYear = updatedDate.toISOString().split("T")[0];
    const minutes = updatedDate.getMinutes();
    const hours = updatedDate.getHours();
    let roundedHour = hours;
    let roundedMinutes = 0;
    if (minutes >= 0 && minutes < 15) {
      roundedMinutes = 0;
    } else if (minutes >= 15 && minutes < 45) {
      roundedMinutes = 30;
    } else {
      roundedMinutes = 0;
      roundedHour += 1;
    }
    if (roundedHour === 24) {
      roundedHour = 0; // Reset to 00 for midnight
    }
    const timeOfDay = `${roundedHour.toString().padStart(2, "0")}:${roundedMinutes.toString().padStart(2, "0")}`;
    if (!validHours.includes(timeOfDay as HourOfDay)) {
      console.warn(`Invalid timeOfDay after rounding: ${updatedDate.toTimeString()} (${timeOfDay})`);
      return;
    }

    let incremented = 0;
    if (collection["Phone Collected"]) {
      result.total.phoneCollections += 1;
      incremented += 1;
    }
    if (collection["Email Collected"]) {
      result.total.emailCollections += 1;
      incremented += 1;
    }
    if (collection["Card Saved"]) {
      if (collection["Profile Length"] === "Short") {
        if (collection["Primary Contact Method"] === "Phone") {
          result.total.cardSavedPhone += 1;
          incremented += 1;
        } else if (collection["Primary Contact Method"] === "Email") {
          result.total.cardSavedEmail += 1;
          incremented += 1;
        }
      } else if (collection["Profile Length"] === "Full") {
        result.total.cardSavedBoth += 1;
        incremented += 2;
      }
    }
    if (incremented > 0) {
      result.total.total += incremented;

      if (!result.byDayOfWeek[dayOfWeek]) {
        result.byDayOfWeek[dayOfWeek] = {
          total: 0,
          phoneCollections: 0,
          emailCollections: 0,
          cardSavedEmail: 0,
          cardSavedPhone: 0,
          cardSavedBoth: 0
        };
      }
      result.byDayOfWeek[dayOfWeek]!.total += incremented;
      if (collection["Phone Collected"]) {
        result.byDayOfWeek[dayOfWeek]!.phoneCollections += 1;
      }
      if (collection["Email Collected"]) {
        result.byDayOfWeek[dayOfWeek]!.emailCollections += 1;
      }
      if (collection["Card Saved"]) {
        if (collection["Profile Length"] === "Short") {
          if (collection["Primary Contact Method"] === "Phone") {
            result.byDayOfWeek[dayOfWeek]!.cardSavedPhone += 1;
          } else if (collection["Primary Contact Method"] === "Email") {
            result.byDayOfWeek[dayOfWeek]!.cardSavedEmail += 1;
          }
        } else if (collection["Profile Length"] === "Full") {
          result.byDayOfWeek[dayOfWeek]!.cardSavedBoth += 1;
        }
      }

      if (!result.byDayOfYear[dayOfYear]) {
        result.byDayOfYear[dayOfYear] = {
          total: 0,
          phoneCollections: 0,
          emailCollections: 0,
          cardSavedEmail: 0,
          cardSavedPhone: 0,
          cardSavedBoth: 0
        };
      }
      result.byDayOfYear[dayOfYear].total += incremented;
      if (collection["Phone Collected"]) {
        result.byDayOfYear[dayOfYear].phoneCollections += 1;
      }
      if (collection["Email Collected"]) {
        result.byDayOfYear[dayOfYear].emailCollections += 1;
      }
      if (collection["Card Saved"]) {
        if (collection["Profile Length"] === "Short") {
          if (collection["Primary Contact Method"] === "Phone") {
            result.byDayOfYear[dayOfYear].cardSavedPhone += 1;
          } else if (collection["Primary Contact Method"] === "Email") {
            result.byDayOfYear[dayOfYear].cardSavedEmail += 1;
          }
        } else if (collection["Profile Length"] === "Full") {
          result.byDayOfYear[dayOfYear].cardSavedBoth += 1;
        }
      }

      if (!result.byTimeOfDay[timeOfDay as HourOfDay]) {
        result.byTimeOfDay[timeOfDay as HourOfDay] = {
          total: 0,
          phoneCollections: 0,
          emailCollections: 0,
          cardSavedEmail: 0,
          cardSavedPhone: 0,
          cardSavedBoth: 0
        };
      }
      result.byTimeOfDay[timeOfDay as HourOfDay]!.total += incremented;
      if (collection["Phone Collected"]) {
        result.byTimeOfDay[timeOfDay as HourOfDay]!.phoneCollections += 1;
      }
      if (collection["Email Collected"]) {
        result.byTimeOfDay[timeOfDay as HourOfDay]!.emailCollections += 1;
      }
      if (collection["Card Saved"]) {
        if (collection["Profile Length"] === "Short") {
          if (collection["Primary Contact Method"] === "Phone") {
            result.byTimeOfDay[timeOfDay as HourOfDay]!.cardSavedPhone += 1;
          } else if (collection["Primary Contact Method"] === "Email") {
            result.byTimeOfDay[timeOfDay as HourOfDay]!.cardSavedEmail += 1;
          }
        } else if (collection["Profile Length"] === "Full") {
          result.byTimeOfDay[timeOfDay as HourOfDay]!.cardSavedBoth += 1;
        }
      }
    }
  });
  return result;
}

export function ProfileCollectDataForType(data: ProfileCollectAnalyticsDaysCombinedInterface, type: MenuOption): StackedBarGraphData {
  let output: StackedBarGraphData = {
    ticks: [],
    segments: [[], []],
    colors: ["#F67902", "#FFA900"]
  };

  if (type === MenuOption.Day) {
    let index = 0;
    for (const day in data.byDayOfYear) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfYear, day)) {
        let dayDate = new Date(day + "T12:00:00.000-06:00");
        let stringVersion = String(dayDate.getMonth() + 1) + "/" + String(dayDate.getDate());
        output.ticks.push(stringVersion);

        output.segments[0].push({
          x: stringVersion,
          y: data.byDayOfYear[day].phoneCollections + data.byDayOfYear[day].cardSavedPhone + data.byDayOfYear[day].cardSavedBoth
        });
        output.segments[1].push({
          x: stringVersion,
          y: data.byDayOfYear[day].emailCollections + data.byDayOfYear[day].cardSavedEmail + data.byDayOfYear[day].cardSavedBoth
        });
        index++;
      }
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.TimeOfDay) {
    const allHours = Object.values(HourOfDay);
    for (const timeSlot of allHours) {
      output.ticks.push(timeSlot);
      const timeData = data.byTimeOfDay[timeSlot] || {
        total: 0,
        phoneCollections: 0,
        emailCollections: 0,
        cardSavedEmail: 0,
        cardSavedPhone: 0,
        cardSavedBoth: 0
      };
      output.segments[0].push({ x: timeSlot, y: timeData.phoneCollections + timeData.cardSavedPhone + timeData.cardSavedBoth });
      output.segments[1].push({ x: timeSlot, y: timeData.emailCollections + timeData.cardSavedEmail + timeData.cardSavedBoth });
    }

    output.tickCount = 7;
  }

  if (type === MenuOption.DayOfWeek) {
    const daysArray = [
      { day: "Mon", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Tue", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Wed", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Thu", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Fri", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Sat", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } },
      { day: "Sun", data: { total: 0, emailCollections: 0, phoneCollections: 0, cardSavedEmail: 0, cardSavedPhone: 0, cardSavedBoth: 0 } }
    ];
    for (const key in data.byDayOfWeek) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfWeek, key)) {
        switch (key as DayOfWeek) {
          case DayOfWeek.Monday:
            daysArray[0].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Tuesday:
            daysArray[1].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Wednesday:
            daysArray[2].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Thursday:
            daysArray[3].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Friday:
            daysArray[4].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Saturday:
            daysArray[5].data = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Sunday:
            daysArray[6].data = data.byDayOfWeek[key];
            break;
        }
      }
    }

    for (let i = 0; i < daysArray.length; i++) {
      const element = daysArray[i];
      output.ticks.push(element.day);
      output.segments[0].push({ x: element.day, y: element.data.phoneCollections + element.data.cardSavedPhone + element.data.cardSavedBoth });
      output.segments[1].push({ x: element.day, y: element.data.emailCollections + element.data.cardSavedEmail + element.data.cardSavedBoth });
    }

    output.tickCount = 7;
  }

  return output;
}

export function TopIntents(data: NLPEventsDaysCombined): BarAndPieChartData[] {
  let output: BarAndPieChartData[] = [];

  for (const key in data.intents) {
    if (Object.prototype.hasOwnProperty.call(data.intents, key)) {
      const element = data.intents[key];
      output.push({ title: key, value: element.total });
    }
  }

  return output;
}

export function groupByLocationId(data) {
  return data.reduce((acc, item) => {
    if (!acc[item.locationId]) {
      acc[item.locationId] = 0;
    }
    acc[item.locationId]++;
    return acc;
  }, {});
}

export const DiscountsData = (rawData: GenericTableRowInterface[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }

  // Follow the exact same pattern as the original Admin DiscountsChart
  const columnNames = Object.keys(rawData[0]).slice(10);
  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    columnNames.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  // Transform and filter out "Intent" like the original
  let transformedData = Object.keys(aggregatedData).map((key) => ({
    title: key.replace("Start", "").trim(),
    value: aggregatedData[key]
  }));

  return transformedData.filter((item) => item.title !== "Intent");
};

export const CallToActionData = (rawData: GenericTableRowInterface[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }

  // Follow the exact same pattern as the original Admin CallToActionChart
  const columnNames = Object.keys(rawData[0]).slice(10);
  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    columnNames.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  return Object.keys(aggregatedData).map((key) => ({
    title: key.replace("Start", "").trim(),
    value: aggregatedData[key]
  }));
};

// Note: Review data transformation functions moved to ReviewDataHelpers.ts for better organization

// Sequences data transformation functions

export interface SequencesAnalyticsDaysCombinedInterface {
  total: number;
  totalClicked?: number;
  byDayOfYear: { [key: string]: number };
  byTimeOfDay: { [key: string]: number };
  byDayOfWeek: { [key: string]: number };
  bySequenceType: { [key: string]: number }; // e.g., { "Day of": 45, "7 days after": 23, ... }
  // Optional fields for SMS click tracking
  byDayOfYearClicked?: { [key: string]: number };
  byTimeOfDayClicked?: { [key: string]: number };
  byDayOfWeekClicked?: { [key: string]: number };
}

// Helper function to extract sequence type from column name
function extractSequenceType(columnName: string): string {
  // Remove channel suffix first
  const withoutChannel = columnName.replace(/ (SMS|Email|Call)$/i, "").trim();

  // Extract the day info
  if (/Day of/i.test(withoutChannel)) {
    return "Day of";
  } else if (/Recurring/i.test(withoutChannel)) {
    return "Recurring";
  } else {
    // Extract number of days for patterns like "7 days after move-in"
    const match = /(\d+)\s*day(?:s)?\s*after/i.exec(withoutChannel);
    if (match) {
      const days = parseInt(match[1]);
      return days === 1 ? "1 day after" : `${days} days after`;
    }
  }

  return withoutChannel; // Fallback to original name without channel
}

// Helper function to determine if a column name represents a sequence being sent
function isSequenceSentColumn(columnName: string, channelType?: "SMS" | "Email" | "Call"): boolean {
  if (!columnName || typeof columnName !== "string") {
    return false;
  }

  // Exclude these specific columns that are NOT sequence sends
  const excludedColumns = ["Account Balance", "SMS Link Clicked", "User ID"];

  if (excludedColumns.includes(columnName)) {
    return false;
  }

  // Include patterns that indicate a sequence was sent
  const sequenceSentPatterns = [
    // Past due sequences
    /Day that payment is due (SMS|Email|Call)/i,
    /\d+\s*day(?:s)?\s*after\s*past\s*due\s*(SMS|Email|Call)/i,

    // Move-out sequences
    /Day of move-out (SMS|Email|Call)/i,
    /\d+\s*day(?:s)?\s*after\s*move-out\s*(SMS|Email|Call)/i,

    // Move-in sequences
    /Day of move-in (SMS|Email|Call)/i,
    /\d+\s*day(?:s)?\s*after\s*move-in\s*(SMS|Email|Call)/i,

    // Lead created sequences (abandoned carts)
    /\d+\s*day(?:s)?\s*after\s*lead\s*is\s*created\s*(SMS|Email|Call)/i,

    // Recurring sequences
    /Recurring\s*(SMS|Email|Call)/i
  ];

  // Check if any pattern matches
  for (const pattern of sequenceSentPatterns) {
    const match = pattern.exec(columnName);
    if (match) {
      // If no channelType specified, return true (backward compatibility)
      if (!channelType) {
        return true;
      }

      // Extract the channel from the matched group (SMS|Email|Call)
      const matchedChannel = match[1];

      // Return true only if the matched channel matches the requested channelType
      return matchedChannel ? matchedChannel.toLowerCase() === channelType.toLowerCase() : false;
    }
  }

  return false;
}

// Helper function to determine if a column name represents an SMS link click
function isSMSLinkClickedColumn(columnName: string): boolean {
  return columnName === "SMS Link Clicked";
}

export function transformSequencesData(
  sequences: GenericTableRowInterface[],
  channelType?: "SMS" | "Email" | "Call",
  tableId?: string
): SequencesAnalyticsDaysCombinedInterface {
  const result: SequencesAnalyticsDaysCombinedInterface = {
    total: 0,
    byDayOfYear: {},
    byTimeOfDay: {},
    byDayOfWeek: {},
    bySequenceType: {}
  };

  const validHours = Object.values(HourOfDay);

  sequences.forEach((sequence) => {
    // Skip deleted sequences - deletedDate comes as a mapped column
    if (sequence["deletedDate"]) {
      return;
    }

    // Filter by tableId if provided
    if (tableId && sequence.tableId !== tableId) {
      return;
    }

    // Check if any sequence-sent field equals 1
    let isSequenceSent = false;
    const sequenceSentColumns: string[] = [];

    // Get all field keys except the standard GenericTableRowInterface fields
    const standardFields = ["id", "userId", "locationId", "tableId", "createdAt", "updatedAt", "orgId", "isHeading"];
    const fieldKeys = Object.keys(sequence).filter((key) => !standardFields.includes(key));

    // Check each field to see if it's a sequence sent column with value 1
    for (const key of fieldKeys) {
      if (isSequenceSentColumn(key, channelType) && (sequence[key] === 1 || sequence[key] === "1")) {
        isSequenceSent = true;
        sequenceSentColumns.push(key);
      }
    }

    if (!isSequenceSent) {
      return;
    }

    // Check for SMS link clicks (only for SMS channel right now)
    let hasLinkClick = false;
    if (channelType === "SMS") {
      for (const key of fieldKeys) {
        if (isSMSLinkClickedColumn(key) && (sequence[key] === 1 || sequence[key] === "1")) {
          hasLinkClick = true;
          break;
        }
      }
    }

    // Increment total
    result.total += 1;

    // Initialize click tracking fields if this is for SMS and we haven't done so yet
    if (channelType === "SMS" && result.totalClicked === undefined) {
      result.totalClicked = 0;
      result.byDayOfYearClicked = {};
      result.byTimeOfDayClicked = {};
      result.byDayOfWeekClicked = {};
    }

    // Increment click total if applicable
    if (hasLinkClick && channelType === "SMS") {
      result.totalClicked! += 1;
    }

    // Process date groupings using updatedAt
    const updatedDate = new Date(sequence.updatedAt);
    const dayOfWeek = updatedDate.toLocaleString("en-US", { weekday: "long" }) as DayOfWeek;
    const dayOfYear = updatedDate.toISOString().split("T")[0];

    // Time of day with 30-minute rounding (same logic as ProfileCollect)
    const minutes = updatedDate.getMinutes();
    const hours = updatedDate.getHours();
    let roundedHour = hours;
    let roundedMinutes = 0;

    if (minutes >= 0 && minutes < 15) {
      roundedMinutes = 0;
    } else if (minutes >= 15 && minutes < 45) {
      roundedMinutes = 30;
    } else {
      roundedMinutes = 0;
      roundedHour += 1;
    }

    if (roundedHour === 24) {
      roundedHour = 0; // Reset to 00 for midnight
    }

    const timeOfDay = `${roundedHour.toString().padStart(2, "0")}:${roundedMinutes.toString().padStart(2, "0")}`;

    if (!validHours.includes(timeOfDay as HourOfDay)) {
      console.warn(`Invalid timeOfDay after rounding: ${updatedDate.toTimeString()} (${timeOfDay})`);
      return;
    }

    // Update day of year count
    if (!result.byDayOfYear[dayOfYear]) {
      result.byDayOfYear[dayOfYear] = 0;
    }
    result.byDayOfYear[dayOfYear] += 1;

    // Update time of day count
    if (!result.byTimeOfDay[timeOfDay as HourOfDay]) {
      result.byTimeOfDay[timeOfDay as HourOfDay] = 0;
    }
    result.byTimeOfDay[timeOfDay as HourOfDay] += 1;

    // Update day of week count
    if (!result.byDayOfWeek[dayOfWeek]) {
      result.byDayOfWeek[dayOfWeek] = 0;
    }
    result.byDayOfWeek[dayOfWeek] += 1;

    if (hasLinkClick && channelType === "SMS") {
      if (!result.byDayOfYearClicked![dayOfYear]) {
        result.byDayOfYearClicked![dayOfYear] = 0;
      }
      result.byDayOfYearClicked![dayOfYear] += 1;

      if (!result.byTimeOfDayClicked![timeOfDay as HourOfDay]) {
        result.byTimeOfDayClicked![timeOfDay as HourOfDay] = 0;
      }
      result.byTimeOfDayClicked![timeOfDay as HourOfDay] += 1;

      if (!result.byDayOfWeekClicked![dayOfWeek]) {
        result.byDayOfWeekClicked![dayOfWeek] = 0;
      }
      result.byDayOfWeekClicked![dayOfWeek] += 1;
    }

    // Update sequence type counts
    for (const columnName of sequenceSentColumns) {
      const sequenceType = extractSequenceType(columnName);
      if (!result.bySequenceType[sequenceType]) {
        result.bySequenceType[sequenceType] = 0;
      }
      result.bySequenceType[sequenceType] += 1;
    }
  });

  return result;
}

export function SequencesDataForType(
  data: SequencesAnalyticsDaysCombinedInterface,
  type: MenuOption | "Type",
  channelType?: "SMS" | "Email" | "Call",
  showClickSegments?: boolean
): StackedBarGraphData {
  // Determine if we should show click segments for SMS
  const shouldShowClickSegments =
    channelType === "SMS" &&
    showClickSegments &&
    type !== "Type" &&
    data.totalClicked !== undefined &&
    data.byDayOfYearClicked &&
    data.byTimeOfDayClicked &&
    data.byDayOfWeekClicked;

  let output: StackedBarGraphData = {
    ticks: [],
    segments: shouldShowClickSegments ? [[], []] : [[]],
    colors: shouldShowClickSegments ? ["#00CABE", "#F67902"] : ["#00CABE"]
  };

  // Handle the custom Type option for sequence type breakdown
  if (type === "Type") {
    // Helper function to sort sequence types chronologically
    const sortSequenceTypes = (a: string, b: string): number => {
      // Define the order: "Day of" first, then numeric days, then "Recurring"
      const getDayNumber = (type: string): number => {
        if (type === "Day of") return 0;
        if (type === "Recurring") return 999;
        const match = /(\d+) days? after/.exec(type);
        return match ? parseInt(match[1]) : 998;
      };

      return getDayNumber(a) - getDayNumber(b);
    };

    // Get all sequence types and sort them
    const sortedTypes = Object.keys(data.bySequenceType)
      .filter((type) => data.bySequenceType[type] > 0) // Only include types with data
      .sort(sortSequenceTypes);

    // Populate the chart data
    for (const sequenceType of sortedTypes) {
      output.ticks.push(sequenceType);
      output.segments[0].push({ x: sequenceType, y: data.bySequenceType[sequenceType] });
    }

    output.tickCount = Math.min(sortedTypes.length, 10);
    return output;
  }

  if (type === MenuOption.Day) {
    // Sort days chronologically
    const sortedDays = Object.keys(data.byDayOfYear).sort();
    for (const day of sortedDays) {
      let dayDate = new Date(day + "T12:00:00.000-06:00");
      let stringVersion = String(dayDate.getMonth() + 1) + "/" + String(dayDate.getDate());
      output.ticks.push(stringVersion);
      output.segments[0].push({ x: stringVersion, y: data.byDayOfYear[day] });

      if (shouldShowClickSegments) {
        const clickCount = data.byDayOfYearClicked![day] || 0;
        output.segments[1].push({ x: stringVersion, y: clickCount });
      }
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.TimeOfDay) {
    const allHours = Object.values(HourOfDay);
    for (const timeSlot of allHours) {
      output.ticks.push(timeSlot);
      const count = data.byTimeOfDay[timeSlot] || 0;
      output.segments[0].push({ x: timeSlot, y: count });

      if (shouldShowClickSegments) {
        const clickCount = data.byTimeOfDayClicked![timeSlot] || 0;
        output.segments[1].push({ x: timeSlot, y: clickCount });
      }
    }
    output.tickCount = 7;
  }

  if (type === MenuOption.DayOfWeek) {
    const daysArray = [
      { day: "Mon", count: 0 },
      { day: "Tue", count: 0 },
      { day: "Wed", count: 0 },
      { day: "Thu", count: 0 },
      { day: "Fri", count: 0 },
      { day: "Sat", count: 0 },
      { day: "Sun", count: 0 }
    ];

    for (const key in data.byDayOfWeek) {
      if (Object.prototype.hasOwnProperty.call(data.byDayOfWeek, key)) {
        switch (key as DayOfWeek) {
          case DayOfWeek.Monday:
            daysArray[0].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Tuesday:
            daysArray[1].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Wednesday:
            daysArray[2].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Thursday:
            daysArray[3].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Friday:
            daysArray[4].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Saturday:
            daysArray[5].count = data.byDayOfWeek[key];
            break;
          case DayOfWeek.Sunday:
            daysArray[6].count = data.byDayOfWeek[key];
            break;
        }
      }
    }

    for (let i = 0; i < daysArray.length; i++) {
      const element = daysArray[i];
      output.ticks.push(element.day);
      output.segments[0].push({ x: element.day, y: element.count });

      if (shouldShowClickSegments) {
        // Map array index to DayOfWeek enum value
        const dayOfWeekValues = [
          DayOfWeek.Monday,
          DayOfWeek.Tuesday,
          DayOfWeek.Wednesday,
          DayOfWeek.Thursday,
          DayOfWeek.Friday,
          DayOfWeek.Saturday,
          DayOfWeek.Sunday
        ];
        const dayOfWeekKey = dayOfWeekValues[i];
        const clickCount = data.byDayOfWeekClicked![dayOfWeekKey] || 0;
        output.segments[1].push({ x: element.day, y: clickCount });
      }
    }
    output.tickCount = 7;
  }

  return output;
}

// ProfileCollect ViewAll transformation functions

export interface TableProfileCollectData {
  id: number;
  userId: number;
  locationId: number;
  locationName: string;
  funnel: string;
  name: string;
  email: string;
  phone: string;
  crmStatus: string;
  notes: string;
  createdAt: Date;
  updatedAt: Date;
  conversationLink: string;
}

// Funnel mapping for better display names
const funnelDisplayNames: { [key: string]: string } = {
  BotInitiated_lowConfidence: "Escalation (Bot Initiated, Low Confidence)",
  BotInitiated_Sales: "Escalation (Bot Initiated, Sales)",
  BotInitiated_Service: "Escalation (Bot Initiated, Service)",
  HumanInitiated: "Escalation (Human Initiated)",
  WhatElse: "What Else",
  Welcome: "Welcome",
  WelcomeBack: "Welcome Back",
  ShoppingFunnel: "Sales",
  LiveChatFirst: "Live Chat First",
  Waitlist: "Waitlist",
  spotReferral: "Referral",
  Cancel: "Cancel",
  ELSE: "Other"
};

export const transformProfileCollectForTable = (
  data: GenericTableRowInterface[],
  locationNames: { [key: number]: string }
): TableProfileCollectData[] => {
  // Filter out deleted items first
  const filteredData = data.filter((item) => !item["deletedDate"]);

  return filteredData.map((item) => {
    const rawFunnel = (item as any)["Funnel"] || "";
    const displayFunnel = funnelDisplayNames[rawFunnel] || rawFunnel;

    return {
      id: item.id,
      userId: item.userId || 0,
      locationId: item.locationId || 0,
      locationName: locationNames[item.locationId || 0] || (item as any)["Location Name"] || `Location ${item.locationId || 0}`,
      funnel: displayFunnel,
      name: "",
      email: "",
      phone: "",
      crmStatus: "Pending",
      notes: "",
      createdAt: new Date(item.createdAt),
      updatedAt: new Date(item.updatedAt),
      conversationLink: `/contact-center/conversations/user/${item.userId || 0}`
    };
  });
};
